module.exports = __webpack_public_path__ + "static/img/index-icon-yhcz.d96eec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/street/index-icon-yhcz.png
// module id = eFFS
// module chunks = 208